import { render, staticRenderFns } from "./input_test.vue?vue&type=template&id=34c605c7&lang=pug&"
import script from "./input_test.vue?vue&type=script&lang=js&"
export * from "./input_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports